module.exports = __webpack_public_path__ + "img/csa_button_playlikegm.c95d00d2.png";